import { Project } from "@/api/types";
import React from "react";
import AppButton from "../structure/AppButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListCheck, IconLookup } from "@fortawesome/free-solid-svg-icons";
import RoleChips from "../auth/RoleChips";

interface ProjectTileProps {
  project: Project;
  showIcon?: boolean; // Optional prop to show the icon
}

export function ProjectTile({ project, showIcon = false }: ProjectTileProps) {
  return (
    <div className="mb-2 flex flex-col bg-white border border-gray-200 rounded-lg shadow-sm md:flex-row hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700">
      <div className="flex items-center justify-center bg-slate-400 text-slate-100 text-6xl rounded-t-lg h-48 md:h-auto md:w-48 md:rounded-none md:rounded-s-lg">
        <FontAwesomeIcon
          icon={{ prefix: "fas", iconName: project.icon || "tarp" } as IconLookup}
        />
      </div>

      <div className="flex flex-col justify-between p-4 leading-normal">
        <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
          {project.name}
        </h5>

        <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
          {project.description}
        </p>

        <div className="mb-3 font-normal text-gray-700 dark:text-gray-400">
          <RoleChips roles={project.roles} />
        </div>

        <div>
          <AppButton
            variant="primary"
            forwardArrow={true}
            href={`/projects/${project.id}`}
          >
            {showIcon && (
              <FontAwesomeIcon icon={faListCheck} className="text-xl mr-2" />
            )}
            View Project
          </AppButton>
        </div>
      </div>
    </div>
  );
}
